import { get } from "../utils/makeRequest";

export const emailLogsService = {
  getLogs: async ({ page = 1, limit = 20 } = {}) =>
    get("/admin/email-logs", { page, limit }),

  getLogDetails: async (id) => get(`/admin/email-logs/${id}`),
};
